<template>
  <div>
    <div class="box" :style="{'min-height':beginHeight+'px','min-width': '1000px'}">
      <hdHead
        :cTitle="plive.lName"
        :cEnd ="plive.lEndDt"
        :cIcon ="plive.lBackUrl"
        :cStart="plive.lStartDt"></hdHead>
      <p style="margin-top: 38px;margin-bottom: 16px;font-size: 20px;">选择直播会场</p>
      <ul ref="list-box" class="live-list clear">
        <li :style="{width: liveItemWidth+'px'}" :class="[i%2===0? '' : 'margin0']" class="clear" v-for="(item,i) in liveList" :key="i">
          <div class="left">
            <i class="edit" style="margin-top: -8px;"></i>
            <span style="display: inline-block;max-width: 240px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
            {{item.roomSubject}}
          </span>
            <div style="margin-top: 5px;">
              <i class="room-icon"></i>
              <span style="font-size: 16px;color: #717171;">{{item.roomName}}</span>
            </div>
          </div>
          <div class="right right-content;" style="margin-top: 20px;">
            <i :class="`living${item.liveStatus}`"></i>
            <span style="color:#32b16c;font-size:16px;" v-if="item.roomlivestatus > 0">正在直播中</span>
            <span style="color:#b6b6b6;font-size:16px;" v-if="item.roomlivestatus === -1">直播未开始</span>
            <span style="color:#00a0e9;font-size:16px;" v-if="item.roomlivestatus === -2">直播已结束</span>
            <button @click="goLivePage(item.roomlivestatus)" class="go-in">进入</button>
          </div>
        </li>
      </ul>
    </div>
    <div class="footer1">
      <img src="./bottom_logo.png" alt="">
    </div>
  </div>
</template>
<script>
  // document.title = "直播互动";
  import hdHead from '../hdHead'
  export default{
    data(){
      return {
        liveList: [],
        beginHeight: 0,
        liveItemWidth: 0, //每个宽度
        plive: '',
        cid: ''
      }
    },
    props: {},
    methods: {
      /**
       * 监听window变化
       */
      listenWresize(){
          window.addEventListener('resize',()=>{
            this.liveItemWidth = Math.floor((this.$refs['list-box'].offsetWidth-5)/2);
            this.beginHeight = document.documentElement.clientHeight-55;
          })
        },
      goLivePage(liveId){
          if(liveId===-1||liveId===-2){
              return;
          }
          this.$router.push({path: `/webpc/hd/${this.cid}/${liveId}`})
      }
    },
    components:{
      hdHead
    },
    computed: {},
    mounted(){
      let cid = this.$route.params.cid;
      this.cid = cid;
      this.listenWresize();
      this.beginHeight = document.documentElement.clientHeight-55;
      this.liveItemWidth = Math.floor((this.$refs['list-box'].offsetWidth-5)/2);
      console.log(this.liveItemWidth);
      axios.request({
        url: '/medapp/api/con/live/roomlist',
        method: 'post', // default
        data: {
          cid: cid
        }
//          headers: {'language': lang}
      }).then((res) => {
        console.log(res);
        this.liveList = res.data.room;
        this.plive = res.data.plive;
      })
    }
  }
</script>
<style scoped>
  .clear:after {
    content: '';
    display: block;
    clear: both;
  }

  .box {
    /*width: 1018px;*/
    padding: 0 150px;
    margin: 0 auto;
    font-size: 16px;
    color: #000000;
  }

  .left {
    float: left;
  }

  .right {
    float: right;
  }


  .live-list li {
    border: 1px solid #C9C9C9;
    /*width: 506px;*/
    box-sizing: border-box;
    padding: 5px;
    font-size: 18px;
    margin-bottom: 14px;
    margin-right: 5px;
    float: left;
  }
  .live-list li.margin0{
    margin-right: 0;
  }

  .live-list li i {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }

  .live-list li i.edit {
    background: url("./edit.png") no-repeat center center/contain;
  }

  .live-list li i.room-icon {
    background: url("./room.png") no-repeat center center/contain;
  }

  .live-list li i.living0 {
    background: url("./livepush.png") no-repeat center center/contain;
  }
  .live-list li i.living1 {
    background: url("./living.png") no-repeat center center/contain;
  }
  .live-list li i.living2 {
    background: url("./liveend.png") no-repeat center center/contain;
  }
  .go-in {
    width: 73px;
    line-height: 32px;
    border-radius: 7px;
    text-align: center;
    background-color: #705f58;
    color: #ffffff;
    font-size: 14px;
    border: 0;
    margin-left: 27px;
    cursor: pointer;
  }

  .right-content {
    margin-top: 30px;
  }
  .footer1{
    width: 100%;
    background-color: #E5E5E5;
    padding: 10px 0;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// hudong.vue?15613ca2